import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import AppContext from "../../../../context/AppContext";
import { Container } from "react-bootstrap";
import { useParams, useNavigate, useLocation } from "react-router-dom"; // ✅ useLocation add kiya
import { FaTag, FaArrowLeft, FaCircle, FaCalendarAlt } from "react-icons/fa";
import "../../../../assets/css/user/blogs/blogdetail/BlogDetail.css";
import MyNavbar from "../../../../components/user/general/mynavbar/MyNavbar";
import Footer from "../../../../components/user/general/footer/Footer";
import tractorblogImg from "../../../../assets/images/home/tractorblog.jpg";
import maintenanceblogImg from "../../../../assets/images/home/maintenanceblog.jpg";
import maintenanceblog1Img from "../../../../assets/images/home/maintenanceblog1.jpg";
import agritechblogImg from "../../../../assets/images/home/agritechblog.jpg";
import agritechblog2Img from "../../../../assets/images/home/agritechblog2.jpg";
import agritechblog3Img from "../../../../assets/images/home/agritechblog3.jpg";
import rentaltipsblogImg from "../../../../assets/images/home/rentaltipblog.jpg";
import userawarenessImg from "../../../../assets/images/home/userawareness.jpg";
import userawareness2Img from "../../../../assets/images/home/userawareness2.jpg";

const BlogDetail = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  const { slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // ✅ current URL check karne ke liye

  // ✅ URL se pata chalega kaun hai
  const isRentalAdmin = location.pathname.startsWith("/rental-admin");

  // ✅ Back button ka path
  const backPath = isRentalAdmin ? "/rental-admin/blogs" : "/blog";

  // const blog = blogsData.find(b => b.slug === slug);

  const fetchSingleBlog = () => {
    axios
      .get(`${baseUrl}/customer/detailblog/fetchSingleBlog/${slug}`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setBlog(response.data.blog);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    console.log("Log from the blog Data");
    fetchSingleBlog();
  }, []);

  if (!blog) {
    return (
      <div className="bd-not-found">
        <Container>
          <h2>Blog not found</h2>
          <button className="bd-back-btn" onClick={() => navigate(backPath)}>
            <FaArrowLeft /> Go Back to Blogs
          </button>
        </Container>
      </div>
    );
  }

  return (
    <>
      {/* ✅ Sirf user ke liye Navbar show hoga */}
      {!isRentalAdmin && <MyNavbar />}

      <div className="bd-page">
        <Container>
          <button className="bd-back-btn" onClick={() => navigate(backPath)}>
            <FaArrowLeft />
            <span>Back to Blogs</span>
          </button>

          <div className="bd-main-card">
            <div className="bd-title-section">
              <h1 className="bd-title">{blog.title}</h1>
            </div>

            <div className="bd-meta-row">
              <div className="bd-author-block">
                <img
                  src={`${baseUrlForFile}/${blog.srsuperadmin?.image}`}
                  alt={blog.srsuperadmin?.fullname}
                  className="bd-author-avatar"
                />

                <div className="bd-author-info">
                  <span className="bd-author-label">Written by</span>
                  <span className="bd-author-name">
                    {blog.srsuperadmin
                      ? `${blog.srsuperadmin?.firstname} ${blog.srsuperadmin?.lastname}`
                      : "Admin"}
                  </span>
                </div>
              </div>
              
            </div>

            <div className="bd-divider" />

            <div className="bd-category-row">
              <span className="bd-category-label">Category</span>
              <span className="bd-category-chip">{blog.category}</span>
            </div>

            <div className="bd-divider" />

            <div className="bd-image-wrapper">
              <img
                src={`${baseUrlForFile}/${blog.image}`}
                alt={blog.title}
                className="bd-hero-image"
              />
              <div className="bd-image-overlay" />
            </div>

            <div className="bd-content-area">
              <div className="bd-description-section">
                <p className="bd-description">{blog.description}</p>
              </div>

              <div className="bd-keywords-section">
                <div className="bd-keywords-label">
                  <FaTag className="bd-tag-icon" />
                  <span>Keywords</span>
                </div>
                <div className="bd-keywords-list">
                  {blog.keywords?.split(",").map((kw, i) => (
                    <span key={i} className="bd-keyword-chip">
                      {kw}
                    </span>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </Container>
      </div>

      {/* ✅ Sirf user ke liye Footer show hoga */}
      {!isRentalAdmin && <Footer />}
    </>
  );
};

export default BlogDetail;